import { APP_ROUTES } from 'swag-client-common/constants/app-routes';
import { CollectSizesUrl } from 'swag-common/utils/urls/collect-sizes.url';
export const ROUTES_WITHOUT_NOTIFICATIONS = [APP_ROUTES.PRODUCT, APP_ROUTES.CART, APP_ROUTES.DELIVERY, APP_ROUTES.CHECKOUT, CollectSizesUrl.BASE_URL, '/sign-contract/'];